module.exports = {
   view: {
      main_text: 'Welcome to M-Duka Vendor Management Portal',
      sub_text: 'Welcome Back, Please Login to Continue',
      forgot_pass: 'Forgot Password',
      login: 'Back to Log In',
   },
   model:{
      email: 'Email Address',
      password: 'Password',
      otp: 'OTP Received',
      confirm_pass: 'Confirm Password',
   }
}